import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
  name: "Supplier",
  components: {
    FormModal,
    Loading,
    BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [mixins],
  data() {
    return {
      url: 'admin/suppliers',
      fields: [{
          key: 'id',
          label: 'شناسه'
        },
        {
          key: 'name',
          label: 'نام'
        },
        {
          key: 'address',
          label: 'آدرس'
        },
        {
          key: 'mobile',
          label: 'موبایل'
        },
        {
          key: 'phone',
          label: 'تلفن'
        },
        {
          key: 'created_at',
          label: 'تاریخ ثبت'
        },
        {
          key: 'edit',
          label: 'ویرایش'
        },
        {
          key: 'delete',
          label: 'حذف'
        },
      ],
      filter: {
        name: '',
        mobile: null,
        phone: null
      },
    }
  },
  mounted() {
    this.loadItems()
  },
  watch: {

  },
methods: {
    async filterItem(page = 1) {
      this.searchParams = {
        name: this.filter.name,
        phone: this.filter.phone,
        mobile: this.filter.mobile,
      }
    },
  }
}
